module.exports = __webpack_public_path__ + "static/media/leaderboard-girl2x.d9734bc0.png";